import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Outlet, useLocation, useNavigate, useSearchParams,
} from 'react-router-dom';
import xCal from '../../lib/calc';
import EventByThemeWidget from '../Partials/EventByThemeWidget';

const Events = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);

  // Календарь
  const calendar = () => {
    const nameId = document.getElementById('date8');

    if (nameId) {
      xCal('date8', {
        id: 'cssworldru8', // Задать уникальный ID
        'class': 'xcalend', // CSS класс оформления внешнего вида
        hide: 0, // Не скрывать календарь
        x: 0, // Отключить кнопку закрытия календаря
        autoOff: 0, // Отключить автоматическое скрытие
        to: 'date8', // Разместить календарь внутри элемента с id=date8
        fn: '', // Вызвать функцию с указанным названием, в нее будет передан результат выбора
      });
    }
  };

  // Handle click value on calendar and pass it to URL;
  const handleSelectSearchByDate = () => {
    if (xCal.value !== null && xCal.value !== undefined) {
      searchParams.set('date', xCal.value);
    } else {
      searchParams.delete('date');
    }
    setSearchParams(searchParams);
  };

  // Handle search document by a number;
  const handleSearchNumber = (e) => {
    const { target } = e;
    if (target.value !== null && target.value !== '') {
      searchParams.set('search_number', target.value);
    } else {
      searchParams.delete('search_number');
    }
    setSearchParams(searchParams);
  };

  const handleKeyPress = () => {
  };

  useEffect(() => {
    calendar();
  }, [searchParams, dictionary]);

  return (
    <section className="main-section">
      <div className="container">
        <h3 className="main-section__title">{dictionary.menus.menu_2}</h3>
        <div className="row">
          <div className="col-lg-9">
            <div className="main-tab">
              <div className="tabs">
                <div className="tabs-box">
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item">
                      <a
                        className={
                          location.pathname === '/news'
                          || location.pathname === '/'
                            ? 'nav-link active'
                            : 'nav-link'
                        }
                        href="/news"
                        id="meetings_tab"
                        data-toggle="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate('news');
                        }}
                        role="tab"
                        aria-controls="news"
                        aria-selected="true"
                      >
                        {dictionary.news}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={
                          location.pathname === '/meetings'
                            ? 'nav-link active'
                            : 'nav-link'
                        }
                        href="/meetings"
                        id="meetings_tab"
                        data-toggle="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate('meetings');
                        }}
                        role="tab"
                        aria-controls="meetings"
                        aria-selected="true"
                      >
                        {dictionary.meetings}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={
                          location.pathname === '/speeches'
                            ? 'nav-link active'
                            : 'nav-link'
                        }
                        href="/speeches"
                        id="meetings-tab"
                        data-toggle="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate('speeches');
                        }}
                        role="tab"
                        aria-controls="speeches"
                        aria-selected="true"
                      >
                        {dictionary.speeches}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={
                          location.pathname === '/trips'
                            ? 'nav-link active'
                            : 'nav-link'
                        }
                        href="/trips"
                        id="trips-tab"
                        data-toggle="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate('trips');
                        }}
                        role="tab"
                        aria-controls="trips"
                        aria-selected="true"
                      >
                        {dictionary.trips}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={
                          location.pathname === '/documents'
                            ? 'nav-link active'
                            : 'nav-link'
                        }
                        href="/documents"
                        id="documents-tab"
                        data-toggle="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate('documents');
                        }}
                        role="tab"
                        aria-controls="documents"
                        aria-selected="true"
                      >
                        {dictionary.menus.menu_5}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={
                          location.pathname === '/missives'
                            ? 'nav-link active'
                            : 'nav-link'
                        }
                        href="/missives"
                        id="missives-tab"
                        data-toggle="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate('missives');
                        }}
                        role="tab"
                        aria-controls="missives"
                        aria-selected="true"
                      >
                        {dictionary.missives}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={
                          location.pathname === '/telegrams'
                            ? 'nav-link active'
                            : 'nav-link'
                        }
                        href="/telegrams"
                        id="telegrams-tab"
                        data-toggle="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate('telegrams');
                        }}
                        role="tab"
                        aria-controls="telegrams"
                        aria-selected="true"
                      >
                        {dictionary.telegrams}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={
                          location.pathname === '/calls'
                            ? 'nav-link active'
                            : 'nav-link'
                        }
                        href="/calls"
                        id="calls-tab"
                        data-toggle="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate('calls');
                        }}
                        role="tab"
                        aria-controls="calls"
                        aria-selected="true"
                      >
                        {dictionary.calls}
                      </a>
                    </li>
                  </ul>
                  <div className="tabs-arrow">
                    <svg
                      width="15"
                      height="8"
                      viewBox="0 0 15 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14 1L7.5 7L1 1"
                        stroke="#3B6B3B"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                <Outlet />
              </div>
            </div>
          </div>

          <div className="col-lg-3 d-none d-lg-block">
            <div className="main-tab">
              <div className="saidbar-content__title">
                <div className="tabs">
                  <div className="tabs-box">
                    <div className="nav nav-tabs">
                      <div className="nav-item">
                        <a href="" onClick={(e) => e.preventDefault()} className="nav-link">{dictionary.calendar}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="saidbar-calendar d-none d-lg-block">
              <div className="calendar">
                <div
                  id="date8"
                  onClick={handleSelectSearchByDate}
                  onKeyDown={(e) => {
                    handleKeyPress(e, xCal.value);
                  }}
                  role="button"
                  tabIndex="0"
                  aria-label="calendar"
                />
              </div>
              <div className="saidbar-calendar__button">
                <button
                  type="button"
                  className="button"
                  onClick={() => {
                    searchParams.delete('date');
                    setSearchParams(searchParams);
                    xCal.value = null;
                  }}
                >
                  {dictionary.restore}
                </button>
              </div>
              {location.pathname === '/documents' ? (
                <div
                  style={{ height: '40px' }}
                  id="document_search"
                  className="search d-none d-lg-block mt-3"
                >
                  <input
                    className="search__input"
                    style={{ height: '100%' }}
                    type="text"
                    onChange={handleSearchNumber}
                    placeholder={dictionary.search_documents}
                    value={searchParams.get('search_number') || ''}
                  />
                  <button
                    type="button"
                    className="search-button"
                  >
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 40 35"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_1016_9838)">
                        <path
                          d="M25.8333 23.3333H24.5167L24.05 22.8833C25.6833 20.9833 26.6667 18.5167 26.6667 15.8333C26.6667 9.85 21.8167 5 15.8333 5C9.85 5 5 9.85 5 15.8333C5 21.8167 9.85 26.6667 15.8333 26.6667C18.5167 26.6667 20.9833 25.6833 22.8833 24.05L23.3333 24.5167V25.8333L31.6667 34.15L34.15 31.6667L25.8333 23.3333ZM15.8333 23.3333C11.6833 23.3333 8.33333 19.9833 8.33333 15.8333C8.33333 11.6833 11.6833 8.33333 15.8333 8.33333C19.9833 8.33333 23.3333 11.6833 23.3333 15.8333C23.3333 19.9833 19.9833 23.3333 15.8333 23.3333Z"
                          fill="#333333"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1016_9838">
                          <rect
                            width="31"
                            height="31"
                            fill="white"
                            transform="translate(0 0.000244141)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </button>
                </div>
              ) : null}
            </div>
            <EventByThemeWidget />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Events;
